<template>
    <el-autocomplete v-model="infoName"
                     valueKey="name"
                     :disabled="disabled"
                     @blur="checkCurrentId"
                     :trigger-on-focus="true"
                     :fetch-suggestions="querySearchAsync"
                     @mouseenter.native="isMouseEnter=true"
                     @mouseleave.native="isMouseEnter=false"
                     :placeholder="placeholder" @select="handleSelectCustom">
        <i class="el-input__icon" :class="infoName&&isMouseEnter&&!disabled?'el-icon-error':'el-icon-edit'" @click="handleClear"
           slot="suffix"></i>
        <template slot-scope="props">
            <div class="name">{{ props.item.name }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
    import CommonSearchInput from './common'
    import { getCustomList , getAccountUnit, getListShip} from "@/api/custom/customList"

    export default {
        mixins: [CommonSearchInput],
        props: {
            isOwner:false,
            isCargoOwner:false,
            disabled:false,
            isShipCompany:false,
            isShipAgent:false,
            isSpecialForm:false
        },
        methods: {
            // 异步搜索信息
            querySearchAsync(queryString, cb) {
                let condition = {
                    'search_LIKE_name': queryString,
                    'iDisplayLength': this.iDisplayLength
                }
                if(this.isOwner){
                    condition['search_EQ_custBusAttribute.isOwner'] = true
                }
                if(this.isCargoOwner){
                    condition['search_EQ_custBusAttribute.isCargoOwner'] = true
                }
                if(this.isShipCompany){
                    condition['search_EQ_custBusAttribute.isShipCompany'] = true
                }
                if(this.isShipAgent){
                    condition['search_EQ_custBusAttribute.isShipAgent'] = true
                }
                let params = this.$assist.copySearchConditions(condition)
                if (this.isSpecialForm) {
                    getAccountUnit(params).then((reponse) => {
                        cb(reponse.data.aaData)
                    })
                } else if (this.isShipAgent || this.isOwner) {
                    getListShip(params).then((reponse) => {
                        cb(reponse.data.aaData)
                    })
                }else{
                    getCustomList(params).then((reponse) => {
                        cb(reponse.data.aaData)
                    })
                }
            },
            handleClear() {
                if (this.infoName&&!this.disabled) {
                    this.infoName = ''
                    this.$emit('matchRecord', Object.assign({}, ''))
                    this.$emit('select', '')
                    this.$emit('selectName', '')
                    this.$emit('selectCode', '')
                    this.$emit('change', '')
                }
            },
            handleSelectCustom(item) {
                this.$emit('matchRecord', Object.assign({}, item))
                this.$emit('select', item.id)
                this.$emit('selectName', item.name)
                this.$emit('selectCode', item.customerCode)
                this.$emit('change', item.id)
            },
            checkCurrentId() {
                if (!this.infoName) {
                    this.$emit('matchRecord', Object.assign({}, ''))
                    this.$emit('select', '')
                    this.$emit('selectName', '')
                    this.$emit('selectCode', '')
                    this.$emit('change', '')
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/autocomplete/autoSearchCustom.vue